<template>
  <main id="main" class="main-site">
    <div class="container">
      <div class="wrap-breadcrumb">
        <ul>
          <li class="item-link">
            <router-link to="/loja" class="fa fa-home"></router-link>
          </li>
          <li class="item-link">
            <router-link to="/loja/minha-conta"><span>Minha Conta</span></router-link>
          </li>
          <li class="item-link">
            <span>2° via Boletos</span>
          </li>
        </ul>
      </div>
      <div class="main-content-area segunda-via">
        <div class="row">
          <div class="col-xs-12">
            <h3 class="box-title first">Atualização de boletos vencidos e 2ª via de boletos</h3>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <figure class="m20">
              <img src="/assets/images/banco_do_brasil.png" style="width:260px;" />
            </figure>
            <p>1) <a href="https://www63.bb.com.br/portalbb/boleto/boletos/hc21e,802,3322,10343.bbx" target="_blank"> 
           <i class="fa fa-link"></i><strong> Clique aqui</strong> </a> para emitir segunda via de boleto de cobrança</p>
            <p>2) Insira a Linha digitável que consta em seu boleto atual no campo solicitado no site (formato: xxxxx.xxxxx xxxxx.xxxxxx xxxxx.xxxxxx x xxxxxxxxxxxxx). Não é necessário preencher nenhum outro campo.</p>
            <p>3) Digite o texto da imagem e clique em “Confirmar”.</p>
            <p>4) Imprima e pague em qualquer correspondente bancário.</p>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <figure class="m20">
              <img src="/assets/images/logo-bradesco.jpg" style="width:188px;" />
            </figure>
            <p>1) <a href="http://banco.bradesco/html/classic/produtos-servicos/mais-produtos-servicos/segunda-via-boleto.shtm" target="_blank"> 
           <i class="fa fa-link"></i><strong> Clique aqui</strong> </a>para acessar atualização de boletos vencidos e segunda via de boletos.</p>
            <p>2) Clique em “Pesquisar boleto pela Linha Digitável”.</p>
            <p>3) Colococar os caracteres de segurança apresentados.</p>
            <p>
              v4) Insira a linha digitável constante em seu boleto no campo solicitado;
              <br>linha digitável: xxxxx.xxxxx xxxxx.xxxxxx xxxxx.xxxxx x xxxxxxxxxxxxxx
            </p>
            <p>5) Digite os caracteres de segurança que aparecerão na imagem e clique em “confirma”.</p>
            <p>6) Imprima.</p>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="alert alert-danger" role="alert">
              <p>
                <i class="fa fa-exclamation-triangle"></i>
                <strong> Error:Evite fraudes na remissão de Boletos</strong>
              </p>
              <p>• Certifique-se de que os 03 primeiros números da linha digitável correspondam ao código do Banco do Brasil "001", HSBC “399” ou Bradesco "237"</p>
              <ul class="clear m20">
                <li>( exemplo boleto Banco do Brasil: 001xx.xxxxx xxxxx.xxxxxx xxxxx.xxxxxx x xxxxxxxxxxxxxx)</li>
                <li>( exemplo boleto HSBC: 399xx.xxxxx xxxxx.xxxxxx xxxxx.xxxxxx x xxxxxxxxxxxxxx)</li>
                <li>( exemplo boleto BRADESCO: 237xx.xxxxx xxxxx.xxxxxx xxxxx.xxxxxx x xxxxxxxxxxxxxx)</li>
              </ul>
              <p>• Sempre acesse o atualizador de boletos diretamente através do site do banco. Nunca clique em links desconhecidos ou provenientes de outros sites.</p>
              <p>• Mantenha seu computador com antivirús atualizado</p>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="alert alert-warning" role="alert">
            <p><i class="fa fa-exclamation-triangle"></i> <strong> Error:Atenção</strong></p>     
<p>• <strong> Para títulos já vencidos:</strong> o vencimento do boleto será atualizado exclusivamente para a data do dia em que for impresso, perdendo a validade se não for quitado no dia. Caso você não quite no mesmo dia, deverá repetir o procedimento acima e atualizar novamente o vencimento.</p>
<p>• Conforme instrução constante no boleto original, os títulos são protestados automaticamente após o 4º dia de vencimento. A partir do momento em que a instrução de protesto for comandada pelo banco, não haverá como atualizar o boleto para realizar pagamentos; neste caso, entre em contato com nosso setor de Recebimento: recebimento@aldo.com.br / (44) 3261-2006.</p>

            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
export default {
  name: "",
  mounted() {
    const self = this;

    $.ajax({
        url: url + "Session.svc/getsessions",
        dataType: "json",
        type: "GET",
        xhrFields: { withCredentials: true },
        error: () => {
          swal({
            title: "É necessário estar logado",
            icon: "warning"
          }).then(() => location.href = `${self.$SiteUrl}/login?redirectTo=` + location.href)
        }
    });
  },
};
</script>
